import React, { useEffect } from 'react';
import { connect } from 'react-redux';

//import { fetchPosts } from '../actions/postsActions';
//import { Post } from '../components/Post';
import { Progress } from '@mantine/core';
import { useSelector } from 'react-redux';
import { FooterSimple } from '../components/FooterSimple';
import { MobileSimpleHeader } from '../components/MobileSimpleHeader';
import { AuthLogInCard } from '../components/AuthLogInCard';
import { AuthRegStepA } from '../components/AuthRegStepA';
import { AuthInitTwoStep } from '../components/AuthInitTwoStep';
import { AuthForgotPw } from '../components/AuthForgotPw';
import { AuthChangePw } from '../components/AuthChangePw';
import { AuthEnterCode } from '../components/AuthEnterCode';



import { CarCreationContain } from '../components/CarCreationContain';
//import { TheAccordianCard } from '../components/AccordianCard';


//add a progress bar at the top
import skull_640 from '../assets/skull_640.png';
import black_and_white_mercedes_benz from '../assets/black_and_white_mercedes_benz.jpg';
import pagani from '../assets/pagani.jpg';

//this needs params
const AuctionItemCreation = () => {
    const photos = [
        {
            src: black_and_white_mercedes_benz,
            width: 1,
            height: 1,
        },
        {
            src: pagani,
            width: 2,
            height: 1,
        },
        {
            src: skull_640,
            width: 1,
            height: 1,
        },
    ];
    return (
        <>
            {/*<MobileSimpleHeader 
                avatar={pagani}
                drawSubSectMenu={false}
            />
            <br/>
            <br/>*/}
            <CarCreationContain />
            <FooterSimple />
        </>
    )

}

export default AuctionItemCreation
